import moment from 'moment'
import Event from './Event';
import LocalStorage from '../local_data';


class CalculateOpeningHours extends Event {
    eventName = 'oms_calculateOpeningHours';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * @event oms_calculateOpeningHours
     * Event Function for calculate opening hours
     * 
     * @param {string} data.client_id - required - id given for client
     * @param {string} data.order_type_id - required - selected order type id
     * @param {string} data.selected_date - required -  selected date (optional)
     * @param {string} data.request_id - optional - unique id for request
     * @param {string} data.action - optional - request action
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id,
            selected_order_type = data.order_type_id,
            selected_delivery_date = data.selected_date;
            let requestId = (data.request_id) ? data.request_id : '';
            let action = (data.action) ? data.action : '';

        if (clientId && selected_order_type) {

            let max_order_days = null,
            max_order_date = null,
            closing_days_array = [],
            opening_days_array = [],
            available_days = [],
            order_before_days = 0,
            current_date = moment().format('YYYY-MM-DD'),
            order_buffer = 15,
            time_steps = 15,
            order_buffer_time = moment().add(order_buffer, 'minutes').format("hh:mm a"),
            closed_time_array = [],
            current_date_time_settings = null,
            flash_delivery_status = null,
            flash_available_days = 0,
            time_settings = [],
            current_time = moment().format("HH:mm:ss"),
            that = this,
            max_preparation_time = 0,
            day_minutes = 24 * 60;

            let locationId = new LocalStorage.CurrentLocation(clientId).getData();
            let openingHours = new LocalStorage.OpeningHours(locationId).getData();
            let settings = new LocalStorage.ClientSettings(clientId).getData();
            let checkoutStatus = new LocalStorage.CheckoutStatus(clientId).getData();
            let products = new LocalStorage.CartLocation(locationId).getData();
            let flash_delivery = (checkoutStatus == 'flash_mode') ? true : false;

            if (settings) {
                settings = settings.data.data;
                let cart_time = (settings.delivery_time_interval) ? settings.delivery_time_interval : "00:15";
                time_steps = moment.duration(moment(current_date + 'T' + cart_time).diff(moment(current_date))).asMinutes();
            }

            if (openingHours) {
                openingHours = openingHours.data.data;

                //get available days for selected order type
                if (openingHours.days) {  
                    let daysArray = null;

                    if (openingHours.days[selected_order_type]) {
                        daysArray = openingHours.days[selected_order_type];
                    }
                    else if (openingHours.days['any']) {
                        daysArray = openingHours.days['any'];
                    }

                    if (daysArray) {
                        daysArray.forEach(function (item) {
                            available_days.push(item.day);
                        });
                    }
                }

                //get special days for selected order type
                if (openingHours.special_days) {  
                    let specialDaysArray = null;
                    let specialDays = openingHours.special_days;

                    if (specialDays[selected_order_type]) {
                        specialDays[selected_order_type].forEach(function (item) {
                            if (item.closed == 1) {
                                closing_days_array.push(item.date);
                                if (opening_days_array.includes(item.date)) {
                                    var index = opening_days_array.indexOf(item.date);
                                    if (index > -1) {
                                        opening_days_array.splice(index, 1);
                                    }
                                }
                            } else if (item.closed == 0) {
                                opening_days_array.push(item.date);
                                if (closing_days_array.includes(item.date)) {
                                    var index = closing_days_array.indexOf(item.date);
                                    if (index > -1) {
                                        closing_days_array.splice(index, 1);
                                    }
                                }
                            }
                        });
                    }
                    if (specialDays['any']) {
                        specialDays['any'].forEach(function (item) {
                            if (!closing_days_array.includes(item.date) && !opening_days_array.includes(item.date)) {
                                if (item.closed == 1) {
                                    closing_days_array.push(item.date);
                                } else if (item.closed == 0) {
                                    opening_days_array.push(item.date);
                                }
                            }
                        });
                    }
                }
            }

            // get location settings
            if (settings && settings.locations) { 
                let locationObj = settings.locations.find(location => location.id === locationId);

                if (locationObj.location_configuration) {
                    max_order_days = (locationObj.location_configuration.calendar_max_days) ? locationObj.location_configuration.calendar_max_days - 1 : null;

                    flash_available_days = (locationObj.location_configuration.flash_available_days) ? locationObj.location_configuration.flash_available_days : 0;
                }

                if (locationObj.order_types) {
                    let orderTypeObj = locationObj.order_types.find(orderType => orderType.id === selected_order_type);
                    
                    let location_order_buffer = orderTypeObj.ordering_buffer;
                    order_before_days = (orderTypeObj.order_before_days) ? orderTypeObj.order_before_days : order_before_days;

                    if (location_order_buffer) {
                        let location_order_buffer_hrs = location_order_buffer.split(':')[0];
                        location_order_buffer_hrs = (location_order_buffer_hrs) ? Number(location_order_buffer_hrs) : 0;

                        if (location_order_buffer_hrs >= 24) {
                            if (location_order_buffer_hrs / 24 > order_before_days) {
                                order_before_days = Math.floor(location_order_buffer_hrs / 24);

                                let location_order_buffer_min = Number(location_order_buffer.split(':')[1]) + Number(moment().format("mm"));
                                location_order_buffer_min = (location_order_buffer_min < 10) ? '0' + location_order_buffer_min.toString() : location_order_buffer_min.toString();
                                
                                location_order_buffer_hrs = location_order_buffer_hrs - order_before_days * 24 + Number(moment().format("HH"));

                                if (location_order_buffer_hrs >= 24) {
                                    order_before_days += 1;
                                    location_order_buffer_hrs -= 24;
                                }
                                
                                location_order_buffer_hrs = (location_order_buffer_hrs < 10) ? '0' + location_order_buffer_hrs.toString() : location_order_buffer_hrs.toString();
                                
                                location_order_buffer = location_order_buffer_hrs + ':' + location_order_buffer_min + ':' + location_order_buffer.split(':')[2];
                            }
                        }
                        else if (order_before_days == 0) {
                            let order_buffer_minutes = (location_order_buffer_hrs * 60) + Number(location_order_buffer.split(':')[1]);
                            
                            let today_current_time = moment().format("HH:mm:ss");
                            let todayEndTime = moment("23:59:00", "HH:mm:ss");
                            let todayStartTime = moment(today_current_time, "HH:mm:ss");
                            let todayRemainingTime = todayEndTime.diff(todayStartTime, 'minutes');

                            if (order_buffer_minutes >= todayRemainingTime) {
                                if (order_buffer_minutes / day_minutes > order_before_days) {
                                    order_before_days += 1;
                                    order_buffer_minutes = order_buffer_minutes - todayRemainingTime;

                                    location_order_buffer_hrs = Math.floor(order_buffer_minutes / 60);
                                    order_buffer_minutes = order_buffer_minutes - location_order_buffer_hrs * 60;

                                    if (location_order_buffer_hrs.toString().length == 1) {
                                        location_order_buffer_hrs = '0' + location_order_buffer_hrs;
                                    }

                                    if (order_buffer_minutes.toString().length == 1) {
                                        order_buffer_minutes = '0' + order_buffer_minutes;
                                    }
                                    
                                    location_order_buffer = location_order_buffer_hrs + ':' + order_buffer_minutes + ':' + location_order_buffer.split(':')[2];
                                }
                            }
                        }
                        else {
                            location_order_buffer = '00:00:00';
                        }
                    }

                    order_buffer = (location_order_buffer) ? moment(current_date + 'T' + location_order_buffer).format('HH:mm') : order_buffer;

                    max_order_days = (locationObj.location_configuration.calendar_max_days) ? locationObj.location_configuration.calendar_max_days + order_before_days - 1 : null;

                    order_buffer = moment.duration(order_buffer).asMinutes();

                    order_buffer_time = moment().add(order_buffer, 'minutes').format("hh:mm a");
                }
            }

            if (products) {
                Object.keys(products).forEach(function (item_id) {
                    let item = products[item_id];
                    let preparationTime = item.item_preparation_time;
                    let preparationMinutes = 0;
    
                    if (preparationTime) {
                        if (!preparationTime.includes(':')) {
                            preparationMinutes = Number(preparationTime) * 60;
                        }
                        else {
                            preparationMinutes = (Number(preparationTime.split(':')[0]) * 60) +  Number(preparationTime.split(':')[1]);
                        }
    
                        max_preparation_time = (preparationMinutes > max_preparation_time) ? preparationMinutes : max_preparation_time;
                    }
                });


                if (max_preparation_time > 0) {
                    let day_minutes = 24 * 60;
    
                    let today_current_time = moment().format("HH:mm:ss");
                    let todayEndTime = moment("23:59:00", "HH:mm:ss");
                    let todayStartTime = moment(today_current_time, "HH:mm:ss");
                    let todayRemainingTime = todayEndTime.diff(todayStartTime, 'minutes');
                    let leadBufferTime = order_before_days * day_minutes + order_buffer - (day_minutes - todayRemainingTime);
                    leadBufferTime = (leadBufferTime > 0) ? leadBufferTime : 0;
                    
    
                    if (max_preparation_time > leadBufferTime) {
                        if (max_preparation_time >= day_minutes) {
                            let preparation_days = Math.floor(max_preparation_time / day_minutes);
                            order_buffer = 0;
    
                            if (preparation_days > order_before_days) {
                                order_before_days = preparation_days;
                            }
    
                            max_preparation_time = max_preparation_time - order_before_days * day_minutes + (day_minutes - todayRemainingTime);
                            order_buffer = max_preparation_time;
    
                            if (preparation_days >= order_before_days) {
                                if (max_preparation_time >= day_minutes) {
                                    order_before_days += 1;
                                }
                            }
                        }
    
                        if (max_preparation_time > order_buffer) {
                            order_buffer = max_preparation_time;
                        }
    
                        if (order_buffer > 0 && max_preparation_time == order_buffer) {
                            order_buffer_time = moment().add(order_buffer, 'minutes').format("HH:mm a");
                        }
                    }
                    
                }
            }


            let timeSelector = (selected_delivery_date) ? true : false;

            if (flash_delivery) {
                if (flash_available_days == 0 || flash_available_days == 1) {
                    let today_current_time = moment().format("HH:mm:ss");
                    let order_buffer_start_time = moment().add(order_buffer, 'minutes').format("HH:mm:ss");

                    if (order_buffer_start_time < today_current_time || order_before_days > 0) {
                        order_buffer = 0;
                        order_buffer_time = moment().add(order_buffer, 'minutes').format("HH:mm a");
                    }

                    time_config(current_date, moment().toDate(), timeSelector);
                } else {
                    let available_days = moment().add(flash_available_days - 1, 'days').format('YYYY-MM-DD');

                    if (selected_delivery_date) {
                        time_config(selected_delivery_date, moment(selected_delivery_date).toDate(), timeSelector);
                    }
                    else {
                        time_config(available_days, moment().add(flash_available_days - 1, 'days').toDate(), timeSelector);
                    }
                }
            }
            else {
                let available_days = moment().add(flash_available_days - 1, 'days').format('YYYY-MM-DD');

                if (selected_delivery_date) {
                    time_config(selected_delivery_date, moment(selected_delivery_date).toDate(), timeSelector);
                }
                else {
                    time_config(available_days, moment().add(max_order_days - 1, 'days').toDate(), timeSelector);
                }
            }


            if (current_date_time_settings != null && current_date_time_settings.special_opening_hours && current_date_time_settings.special_opening_hours.length > 0 && current_date_time_settings.special_opening_hours[current_date_time_settings.special_opening_hours.length - 1].max_order_time) {

                let current_time = moment().format("HH:mm:ss");
                let selected_max_order_time = current_date_time_settings.special_opening_hours[current_date_time_settings.special_opening_hours.length - 1].max_order_time;

                if (current_time > selected_max_order_time) {
                    order_before_days = order_before_days + 1;
                }

            } else if (current_date_time_settings && current_date_time_settings.opening_hours && current_date_time_settings.opening_hours.length > 0 && current_date_time_settings.opening_hours[current_date_time_settings.opening_hours.length - 1].max_order_time) {
                let current_time = moment().format("HH:mm:ss");
                let selected_max_order_time = current_date_time_settings.opening_hours[current_date_time_settings.opening_hours.length - 1].max_order_time;

                if (current_time > selected_max_order_time) {
                    order_before_days = order_before_days + 1;
                }

            }


            if (flash_delivery) {

                if (current_date_time_settings && current_date_time_settings.special_opening_hours && current_date_time_settings.special_opening_hours.length > 0 && current_date_time_settings.special_opening_hours[current_date_time_settings.special_opening_hours.length - 1].max_flash_order_time) {

                    let current_time = null;

                    if (flash_available_days == 0 || flash_available_days == 1) {
                        current_time = moment().add(order_buffer, 'minutes').format("HH:mm:ss");
                    }

                    let selected_max_flash_order_time = (current_date_time_settings.special_opening_hours[current_date_time_settings.special_opening_hours.length - 1].max_flash_order_time) ? current_date_time_settings.special_opening_hours[current_date_time_settings.special_opening_hours.length - 1].max_flash_order_time : current_date_time_settings.special_opening_hours[current_date_time_settings.special_opening_hours.length - 1].max_order_time;

                    if (current_time != null && current_time > selected_max_flash_order_time) {
                        flash_delivery_status = 'close';
                    }

                } else if (current_date_time_settings && current_date_time_settings.opening_hours && current_date_time_settings.opening_hours.length > 0 && current_date_time_settings.opening_hours[current_date_time_settings.opening_hours.length - 1].max_flash_order_time) {

                    let current_time = null;

                    if (flash_available_days == 0 || flash_available_days == 1) {
                        current_time = moment().add(order_buffer, 'minutes').format("HH:mm:ss");
                    }

                    let selected_max_flash_order_time = (current_date_time_settings.opening_hours[current_date_time_settings.opening_hours.length - 1].max_flash_order_time) ? current_date_time_settings.opening_hours[current_date_time_settings.opening_hours.length - 1].max_flash_order_time : current_date_time_settings.opening_hours[current_date_time_settings.opening_hours.length - 1].max_order_time;

                    if (current_time != null && current_time > selected_max_flash_order_time) {
                        flash_delivery_status = 'close';
                    }

                }

            }



            //time_selector = (true) ? Do calculation and draw timepicker : Get opening hours settings.
            function time_config(dateText, selected_date, time_selector) {

                let selected_date_settings = null;
                let modified_date_settings = [];
                let selected_date_text = moment(selected_date).format('YYYY-MM-DD');

                let day_of_week = moment(selected_date).format('dddd'); 

                //Get selected date settings.
                if (openingHours && openingHours.special_days) {
                    let exist_order_type = 0;
                    Object.keys(openingHours.special_days).forEach(function (index) {
                        let ele = openingHours.special_days[index];

                        if (index == selected_order_type) {
                            ele.forEach(function (obj) {

                                if (obj.date == selected_date_text) {
                                    if (obj.closed == 0) {
                                        selected_date_settings = obj;
                                    }

                                    if (flash_delivery == true && obj.closed == 1 && (flash_available_days == 0 || flash_available_days == 1)) {
                                        flash_delivery_status = 'close';
                                    }

                                    if (flash_delivery == true && obj.closed == 0) {
                                        flash_delivery_status = 'open';
                                    }
                                    exist_order_type = 1;

                                }
                            });
                            
                        }
                        if (index == 'any') {
                            ele.forEach(function (obj) {

                                if ((obj.date == selected_date_text)  && (exist_order_type == 0)) {
                                    if (obj.closed == 0) {
                                        selected_date_settings = obj;
                                    }

                                    if (flash_delivery == true && obj.closed == 1 && (flash_available_days == 0 || flash_available_days == 1)) {
                                        flash_delivery_status = 'close';
                                    }

                                    if (flash_delivery == true && obj.closed == 0) {
                                        flash_delivery_status = 'open';
                                    }

                                }
                            });
                        }
                    });

                }

                if (selected_date_settings == null) {
                    if (openingHours && openingHours.days) {
                        let days_array = [];
                        let exist_order_type = 0;

                        Object.keys(openingHours.days).forEach(function (index) {
                            let ele = openingHours.days[index];

                            if (index == selected_order_type) {
                                ele.forEach(function (obj) {

                                    days_array.push(obj.day);

                                    if (obj.day == day_of_week) {
                                        selected_date_settings = obj;
                                    }

                                });
                                exist_order_type = 1;
                            }
                            else if ((index == 'any') && (exist_order_type == 0)) {
                                ele.forEach(function (obj) {

                                    days_array.push(obj.day);

                                    if (obj.day == day_of_week) {
                                        selected_date_settings = obj;
                                    }

                                });
                            }
                        });

                        if (flash_delivery == true && flash_delivery_status == null && days_array.length > 0 && days_array.includes(day_of_week) == false && (flash_available_days == 0 || flash_available_days == 1)) {
                            flash_delivery_status = 'close';
                        }

                    }
                }

                if (time_selector === true) {

                    if (selected_date_settings && selected_date_settings.hasOwnProperty('special_opening_hours') && selected_date_settings.special_opening_hours != null && selected_date_settings.special_opening_hours.length > 0) {
                        let order_range_array = [];
                        let flash_order_range_array = [];
                        let tomorrow_date  = moment().add(1,'days').format('YYYY-MM-DD');

                        selected_date_settings.special_opening_hours.forEach(function (obj) {
                            order_range_array.push({
                                'start': obj.open_at,
                                'end': obj.max_order_time
                            });
                            flash_order_range_array.push({
                                'start': obj.open_at,
                                'end': (obj.max_flash_order_time) ? obj.max_flash_order_time : obj.max_order_time
                            });
                        });

                        if (flash_delivery == true && (flash_available_days == 0 || flash_available_days == 1)) {
                            calculate_close_times(flash_order_range_array);
                            closed_time_array.push(['00:00 am', order_buffer_time]);
                        } 
                        else if (flash_delivery == true) {
                            calculate_close_times(flash_order_range_array);
                            if (selected_date_text == current_date) {
                                closed_time_array.push(['00:00 am', order_buffer_time]);

                                if (selected_date_settings != null && selected_date_settings.hasOwnProperty('special_opening_hours') && selected_date_settings.special_opening_hours != null && selected_date_settings.special_opening_hours.length > 0 && selected_date_settings.special_opening_hours[selected_date_settings.special_opening_hours.length - 1].hasOwnProperty('max_flash_order_time')) {

                                    let current_time = moment().add(order_buffer, 'minutes').format("HH:mm:ss");
                                    let selected_max_order_time = (selected_date_settings.special_opening_hours[selected_date_settings.special_opening_hours.length - 1].max_flash_order_time) ? selected_date_settings.special_opening_hours[selected_date_settings.special_opening_hours.length - 1].max_flash_order_time : selected_date_settings.special_opening_hours[selected_date_settings.special_opening_hours.length - 1].max_order_time;

                                }


                            } 

                        } else {
                            calculate_close_times(order_range_array);

                            if (dateText == current_date) {
                                closed_time_array.push(['00:00 am', order_buffer_time]);

                                if (current_date_time_settings != null && current_date_time_settings.hasOwnProperty('special_opening_hours') && current_date_time_settings.special_opening_hours != null && current_date_time_settings.special_opening_hours.length > 0 && current_date_time_settings.special_opening_hours[current_date_time_settings.special_opening_hours.length - 1].hasOwnProperty('max_order_time') && current_date_time_settings.special_opening_hours[current_date_time_settings.special_opening_hours.length - 1].max_order_time != null) {

                                    let current_time = moment().add(order_buffer, 'minutes').format("HH:mm:ss");
                                    let selected_max_order_time = current_date_time_settings.special_opening_hours[current_date_time_settings.special_opening_hours.length - 1].max_order_time;
                                }

                            }
                            // else if (dateText == tomorrow_date) {
                            else {

                                let today_current_time = moment().format("HH:mm:ss");

                                let todayEndTime = moment("23:59:00", "HH:mm:ss");
                                let todayStartTime = moment(today_current_time, "HH:mm:ss");
                                let todayRemainingTime = todayEndTime.diff(todayStartTime, 'minutes');

                                if (order_buffer > todayRemainingTime) {
                                    let tomorrowBufferTime = order_buffer - todayRemainingTime;
                                    let tomorrowStartTime = moment("00:00:00", "HH:mm:ss").add(tomorrowBufferTime, 'minutes').format("HH:mm a");
                                    closed_time_array.push(['00:00 am', tomorrowStartTime]);
                                }
                            } 
                        }

                        if (selected_date_settings.special_opening_hours.length > 0) {
                            array_sort(selected_date_settings.special_opening_hours).then(result => {

                                modified_date_settings.push({
                                    open_at: result[0].open_at,
                                    close_at: result[result.length - 1].close_at,
                                    max_order_time: result[result.length - 1].max_order_time,
                                    max_flash_order_time: (result[result.length - 1].max_flash_order_time) ? result[result.length - 1].max_flash_order_time : result[result.length - 1].max_order_time,
                                    disable_time_range: closed_time_array
                                });
                            });
                        } 

                    } else {
                        let order_range_array = [];
                        let flash_order_range_array = [];
                        let tomorrow_date  = moment().add(1,'days').format('YYYY-MM-DD');

                        if (selected_date_settings && selected_date_settings.hasOwnProperty('opening_hours') && selected_date_settings.opening_hours.length > 0) {
                            selected_date_settings.opening_hours.forEach(function (item) {
                                order_range_array.push({
                                    'start': item.open_at,
                                    'end': item.max_order_time
                                });
                                flash_order_range_array.push({
                                    'start': item.open_at,
                                    'end': (item.max_flash_order_time) ? item.max_flash_order_time : item.max_order_time
                                });
                            });
                        }

                        if (flash_delivery == true && (flash_available_days == 1 || flash_available_days == 0)) {
                            calculate_close_times(flash_order_range_array);
                            closed_time_array.push(['00:00 am', order_buffer_time]);
                        } else if (flash_delivery == true) {
                            calculate_close_times(flash_order_range_array);
                            if (dateText == current_date) {
                                closed_time_array.push(['00:00 am', order_buffer_time]);

                                if (selected_date_settings != null && selected_date_settings.hasOwnProperty('opening_hours') && selected_date_settings.opening_hours != null && selected_date_settings.opening_hours.length > 0 && selected_date_settings.opening_hours[selected_date_settings.opening_hours.length - 1].hasOwnProperty('max_flash_order_time')) {

                                    let current_time = moment().add(order_buffer, 'minutes').format("HH:mm:ss");
                                    let selected_max_order_time = (selected_date_settings.opening_hours[selected_date_settings.opening_hours.length - 1].max_flash_order_time) ? selected_date_settings.opening_hours[selected_date_settings.opening_hours.length - 1].max_flash_order_time : selected_date_settings.opening_hours[selected_date_settings.opening_hours.length - 1].max_order_time;
                                }

                            } else {
                                let todayStartTime = moment("00:00:00", "HH:mm:ss");
        
                                let openingDate = moment().add(order_before_days,'days').format('YYYY-MM-DD');
                                if (dateText == openingDate) {
                                    let tomorrowStartTime = todayStartTime.add(order_buffer, 'minutes').format("HH:mm a");
                                    closed_time_array.push(['00:00 am', tomorrowStartTime]);
                                }
                            }

                        } else {
                            calculate_close_times(order_range_array);

                            if (dateText == current_date) {
                                closed_time_array.push(['00:00 am', order_buffer_time]);

                                if (current_date_time_settings != null && current_date_time_settings.hasOwnProperty('opening_hours') && current_date_time_settings.opening_hours != null && current_date_time_settings.opening_hours.length > 0 && current_date_time_settings.opening_hours[current_date_time_settings.opening_hours.length - 1].hasOwnProperty('max_order_time') && current_date_time_settings.opening_hours[current_date_time_settings.opening_hours.length - 1].max_order_time != null) {

                                    let current_time = moment().add(order_buffer, 'minutes').format("HH:mm:ss");
                                    let selected_max_order_time = current_date_time_settings.opening_hours[current_date_time_settings.opening_hours.length - 1].max_order_time;

                                }

                            } 
                            // else if (moment(selected_date).format("YYYY-MM-DD") == tomorrow_date) {
                            else {
                                let todayStartTime = moment("00:00:00", "HH:mm:ss");
        
                                let openingDate = moment().add(order_before_days,'days').format('YYYY-MM-DD');
                                if (dateText == openingDate) {
                                    let tomorrowStartTime = todayStartTime.add(order_buffer, 'minutes').format("HH:mm a");
                                    closed_time_array.push(['00:00 am', tomorrowStartTime]);
                                }
                            }

                        }

                        if (current_date == selected_delivery_date) {
                            closed_time_array.push(["00:00 am", order_buffer_time]);
                        }
                        else if (dateText == tomorrow_date) {

                            let today_current_time = moment().format("HH:mm:ss");

                            let todayEndTime = moment("23:59:00", "HH:mm:ss");
                            let todayStartTime = moment(today_current_time, "HH:mm:ss");
                            let todayRemainingTime = todayEndTime.diff(todayStartTime, 'minutes');

                            if (order_buffer > todayRemainingTime) {
                                let tomorrowBufferTime = order_buffer - todayRemainingTime;
                                let tomorrowStartTime = moment("00:00:00", "HH:mm:ss").add(tomorrowBufferTime, 'minutes').format("HH:mm a");
                                closed_time_array.push(['00:00 am', tomorrowStartTime]);
                            }
                        }
                        

                        if (selected_date_settings && selected_date_settings.opening_hours && selected_date_settings.opening_hours.length > 0) {
                            array_sort(selected_date_settings.opening_hours).then(result => {

                                modified_date_settings.push({
                                    open_at: result[0].open_at,
                                    close_at: result[result.length - 1].close_at,
                                    max_order_time: result[result.length - 1].max_order_time,
                                    max_flash_order_time: (result[result.length - 1].max_flash_order_time) ? result[result.length - 1].max_flash_order_time: result[result.length - 1].max_order_time,
                                    disable_time_range: closed_time_array
                                });

                            });
                            
                        }
                        else if (selected_date_settings == null && current_date == selected_delivery_date) {
                            array_sort(["00:00 am", order_buffer_time]).then(result => {

                                modified_date_settings.push({
                                    open_at: result[0].open_at,
                                    close_at: result[result.length - 1].close_at,
                                    max_order_time: result[result.length - 1].max_order_time,
                                    max_flash_order_time: (result[result.length - 1].max_flash_order_time) ? result[result.length - 1].max_flash_order_time: result[result.length - 1].max_order_time,
                                    disable_time_range: closed_time_array
                                });

                            });
                        }
                        else if (!modified_date_settings || modified_date_settings && modified_date_settings.length == 0) {
                            modified_date_settings.push({
                                disable_time_range: closed_time_array
                            });
                        }
                    }

                    time_settings = modified_date_settings;

                    

                } else {
                    current_date_time_settings = selected_date_settings;
                }

                if (flash_delivery == true && flash_delivery_status == null) {
                    flash_delivery_status = 'open';
                }

            }

            let today_current_time = moment().format("HH:mm:ss");

            let todayEndTime = moment("23:59:00", "HH:mm:ss");
            let todayStartTime = moment(today_current_time, "HH:mm:ss");
            let todayRemainingTime = todayEndTime.diff(todayStartTime, 'minutes');

            if (order_buffer > todayRemainingTime) {
                if (!closing_days_array.includes(current_date)) {
                    closing_days_array.push(current_date);
                }
            }

            successEvent();


            function array_sort(array) {
                return new Promise((resolve, reject) => {
                    array.sort((a, b) => {
                        let item_1 = giveUtc(a.open_at);
                        let item_2 = giveUtc(b.open_at);
                        if (item_1 < item_2) {
                            return -1;
                        }
                        if (item_1 > item_2) {
                            return 1;
                        }
                        return 0;
                    });
                    resolve(array);
                });
            }

            // Start get close times function

            function giveUtc(start) {
                let time = moment().format("YYYY-MM-DD");
                let time_start = time + " " + start;
                return moment(time_start, "YYYY-MM-DD HH:mm:ss").format();
            }

            function calculate_close_times(time_range) {

                time_range.sort((a, b) => {
                    let item_1 = giveUtc(a.start);
                    let item_2 = giveUtc(b.start);
                    if (item_1 < item_2) {
                        return -1;
                    }
                    if (item_1 > item_2) {
                        return 1;
                    }
                    return 0;
                });

                let availableTimeArray = [];

                let endTimeFarthest = moment(giveUtc("00:00:00"));
                let startTimeMinimum = moment(giveUtc("23:59:00"));

                time_range.forEach((element, index) => {
                    if (element.start == "00:00:00") {
                        element.start = "00:01:00";
                    }
                    if (element.end == "23:59:00") {
                        element.end = "23:58:00";
                    }

                    let currentEndTime = moment(giveUtc(element.end)).add(1, 'minute'); 
                    let currentStartTime = moment(giveUtc(element.start)).subtract(1, 'minute'); 

                    if (currentStartTime.isBefore(startTimeMinimum)) {
                        startTimeMinimum = currentStartTime;
                    }

                    if (currentEndTime.isAfter(endTimeFarthest)) {
                        endTimeFarthest = currentEndTime;
                    }

                    if (index === time_range.length - 1) {
                        if (time_range.length === 1) {
                            availableTimeArray.push(["00:00 am", currentStartTime.format("h:mm a")]);
                        }
                        availableTimeArray.push([endTimeFarthest.format("h:mm a"), "11:59 pm"]);
                    } else {
                        let nextBusyTime = time_range[index + 1];
                        let nextStartTime = moment(giveUtc(nextBusyTime.start));
                        if (index === 0) {
                            availableTimeArray.push(["00:00 am", currentStartTime.format("h:mm a")]);
                        }
                        let endTimeToCompare = currentEndTime.isBefore(endTimeFarthest) ? endTimeFarthest : currentEndTime;
                        if (endTimeToCompare.isBefore(nextStartTime)) {
                            availableTimeArray.push([endTimeToCompare.format("h:mm a"), nextStartTime.format("h:mm a")]);
                        }
                    }

                });

                closed_time_array = availableTimeArray;

            }

            
            function successEvent() {
                that.onSuccessEvent({
                    "data": {
                        "available_days": available_days,
                        "closed_time_array": closed_time_array,
                        "opening_days_array": opening_days_array,
                        "closing_days_array": closing_days_array,
                        "max_days": max_order_days,
                        "order_before_days": order_before_days,
                        "flash_delivery_status": flash_delivery_status,
                        "flash_available_days": flash_available_days,
                        "time_settings": time_settings
                    },
                },
                {
                    'action' : action, 
                    'request_id' : requestId 
                });
            }

            //this.dispatch(this.eventName + 'Success', { "result": data});

        }
        else {
            //fire error event
            this.onErrorEvent({ "message": "client_id & order_type_id is required", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default CalculateOpeningHours;